export default __webpack_public_path__ + "static/media/home-fond2.2fc3d9d7.jpeg";